import React, { ComponentProps, FC } from 'react';
import styled from 'styled-components';

import { TextButton } from '../../Button';

export const TableAction: FC<ComponentProps<typeof TextButton>> = (props) => (
  <TableActionButton {...props} size="small" />
);

const TableActionButton = styled(TextButton)`
  padding: 0.25em 1em; /* TODO: theme */
`;
